/*
 * Спосіб останньої взаємодії — клавіатура чи вказівник (атрибут `data-input` на <html>).
 * Правило руху (DESIGN.md, «Наскрізні правила (2E)»): шари, відкриті чи закриті з клавіатури (Q — нова задача,
 * Enter — картка, «?» — клавіші, Shift+F10 — меню, Esc), з’являються й зникають без анімації — клавіатурні дії
 * часті й не мають чекати руху. Відкриті мишею чи дотиком шари рухаються за звичайними правилами.
 */

const MODIFIERS = new Set(['Shift', 'Control', 'Alt', 'Meta', 'CapsLock', 'Fn', 'OS']);

let installed = false;

export function installInputModality(): void {
  if (installed || typeof document === 'undefined') return;
  installed = true;
  const root = document.documentElement;
  document.addEventListener(
    'keydown',
    (e) => {
      // Сам модифікатор (Shift для вибору кількох рядків мишею) не робить взаємодію клавіатурною.
      if (!MODIFIERS.has(e.key) && root.dataset.input !== 'keyboard') root.dataset.input = 'keyboard';
    },
    true,
  );
  document.addEventListener(
    'pointerdown',
    () => {
      if (root.dataset.input !== 'pointer') root.dataset.input = 'pointer';
    },
    true,
  );
}

/** Остання взаємодія — з клавіатури: шари закриваються без анімації виходу. */
export function isKeyboardModality(): boolean {
  return typeof document !== 'undefined' && document.documentElement.dataset.input === 'keyboard';
}
